import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-manager",
  "use": "icon-manager-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-manager\">\n<path d=\"M13.9705 11.4314C16.2558 12.1426 18.0839 13.4123 19.4549 15.2404C20.8258 17.0686 21.5284 19.1759 21.5625 21.5625H0.4375C0.471625 19.1759 1.17417 17.0686 2.54513 15.2404C3.91608 13.4123 5.74421 12.1426 8.0295 11.4314L11 15.875L13.9705 11.4314ZM16.2812 5.71875C16.2471 7.20833 15.7309 8.45254 14.7326 9.45138C13.7343 10.4502 12.4901 10.9664 11 11C9.51042 10.9659 8.26621 10.4497 7.26737 9.45138C6.26854 8.45308 5.75233 7.20888 5.71875 5.71875C5.75287 4.22917 6.26908 2.98496 7.26737 1.98613C8.26567 0.987292 9.50988 0.471083 11 0.4375C12.4896 0.471625 13.7338 0.987833 14.7326 1.98613C15.7315 2.98442 16.2477 4.22863 16.2812 5.71875Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/manager.svg
// module id = M8dW
// module chunks = 258